<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import TheHeader from '@/components/layouts/header/TheHeader.vue'
import { useEnsureCurrentUser } from '@/composables/useEnsureCurrentUser'

const { t } = useI18n()
const { isInitialized } = useEnsureCurrentUser()
</script>

<template>
  <div
    v-if="!isInitialized"
    class="bg-background flex h-dvh flex-col items-center justify-center gap-3"
  >
    <div
      class="border-muted-foreground/30 border-t-muted-foreground/70 h-8 w-8 animate-spin rounded-full border-2"
    />
    <span class="text-muted-foreground/70 animate-pulse text-sm">
      {{ t('common.loading') }}
    </span>
  </div>
  <div
    v-else
    class="bg-background flex min-h-screen w-full flex-col items-center space-y-4"
  >
    <TheHeader />

    <div class="flex min-h-0 w-full flex-1 flex-col rounded-md pt-2">
      <!-- Main Content -->
      <RouterView v-slot="{ Component, route }">
        <Transition name="fade" mode="out-in">
          <main
            :key="route.name"
            class="flex min-h-0 w-full flex-1 flex-col items-center"
          >
            <Component :is="Component" />
          </main>
        </Transition>
      </RouterView>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active {
  transition: all 0.3s ease-out;
}

.fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
